var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 13.0007L22.7499 22.7507M12.9999 13.0007H6.49992L4.33325 6.50065L6.49992 4.33398L12.9999 6.50065V13.0007ZM26 32.5005L37.9166 44.4171C39.7115 46.212 42.6216 46.212 44.4166 44.4171C46.2115 42.6222 46.2115 39.712 44.4165 37.9171L34.6131 28.1138C33.9191 28.0481 33.2425 27.9229 32.5883 27.7434C31.7453 27.512 30.8206 27.6799 30.2025 28.2981L26 32.5005Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7277 5.93951L36.0346 11.6327C35.1765 12.4907 34.7475 12.9197 34.5868 13.4144C34.4454 13.8496 34.4454 14.3184 34.5868 14.7535C34.7475 15.2482 35.1765 15.6773 36.0346 16.5353L36.5486 17.0493C37.4067 17.9074 37.8357 18.3364 38.3304 18.4971C38.7655 18.6385 39.2343 18.6385 39.6695 18.4971C40.1642 18.3364 40.5932 17.9074 41.4512 17.0493L46.7767 11.7239C47.3503 13.1196 47.6666 14.6482 47.6666 16.2507C47.6666 22.832 42.3313 28.1673 35.7499 28.1673C34.9565 28.1673 34.1811 28.0898 33.4311 27.9418C32.3778 27.7341 31.8511 27.6302 31.5318 27.6621C31.1924 27.6959 31.0251 27.7468 30.7244 27.9077C30.4415 28.0591 30.1577 28.3429 29.5901 28.9104L14.0833 44.4173C12.2883 46.2122 9.37818 46.2122 7.58325 44.4173C5.78833 42.6224 5.78833 39.7122 7.58326 37.9173L23.0901 22.4104C23.6577 21.8429 23.9415 21.5591 24.0929 21.2762C24.2538 20.9755 24.3047 20.8082 24.3385 20.4687C24.3703 20.1495 24.2665 19.6228 24.0587 18.5695C23.9108 17.8194 23.8333 17.0441 23.8333 16.2507C23.8333 9.66926 29.1685 4.33398 35.7499 4.33398C37.9285 4.33398 39.9705 4.9186 41.7277 5.93951Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTool);
export default __webpack_public_path__ + "static/media/IconTool.45cbe24f45567c537b340e4506bcd3a4.svg";
export { ForwardRef as ReactComponent };